import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from '@/components/action-sheet';
import {
  AllowedShortcuts,
  KeyboardScope,
} from '@/platform/shortcuts/operator-shortcuts';
import { useKeyboardShortcuts } from '@platform/shortcuts/hooks/use-keyboard-shortcuts';

interface Props {
  onChooseSubstitute: () => void;
  onClose: () => void;
  onSubmitOrder: () => void;
  submitOrderText: string;
}

export const SubstitutionConfirmationActionSheet: React.FC<Props> = ({
  onChooseSubstitute,
  onClose,
  onSubmitOrder,
  submitOrderText,
}) => {
  useKeyboardShortcuts(
    AllowedShortcuts.PlaceOrder,
    onSubmitOrder,
    [],
    {},
    true,
    KeyboardScope.ACTION_SHEET,
  );

  return (
    <ActionSheet
      actions={[submitOrderText, i18n.t('choose_substitute')]}
      isFocusableForKeyboardShortcuts
      isVisible
      message={i18n.t('substitution_confirmation.message')}
      onAction={(_, i) => {
        if (i === 0) {
          // we are not allowing substitutions in offline mode M1, so this sheet will not be shown
          Analytics.track('substitution_confirmation.place_order_button.press');
          onSubmitOrder();
        } else {
          Analytics.track(
            'substitution_confirmation.choose_substitute_button.press',
          );
          onChooseSubstitute();
        }
      }}
      onClose={onClose}
      primaryIndices={[0]}
      title={i18n.t('substitution_confirmation.title')}
    />
  );
};
